import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HARDWARE_ORDERS_QUERY_KEY } from "@/common/hooks/use-hardware-orders-query";
import { OrdersService } from "@/services/orders/orders-service";
import type { CreateOrderRequest, CreateOrderResponse } from "@/services/orders/orders.types";

const ordersService = new OrdersService();

/**
 * React Query mutation for submitting a hardware order. Mirrors the pattern
 * used by useHardwareCatalog (useQuery wrapper around a service call) but for
 * a write operation.
 */
export const useCreateOrder = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateOrderResponse, Error, CreateOrderRequest>({
    mutationFn: (request) => ordersService.createOrder(request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HARDWARE_ORDERS_QUERY_KEY }),
  });
};
